// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"2cf5f06a","741":"1c229b18","845":"43df4d5c"}[chunkId] + ".chunk.css";
};